import { Add } from "@mui/icons-material";
import { Box, Button, Container, Tab } from "@mui/material";
import React, { useState } from "react";
import HistoryMerchantUser from "./HistoryMerchantUser";
import PendingMerchantUser from "./PendingMerchantUser";
import ViewMerchantUser from "./ViewMerchantUser";
import HeaderHelpPage from "../HeaderHelpPage";
import { writeLog } from "../../services/services";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";
import CreateNewMerchantUser from "../../pages/Admin/CreateNewMerchantUser";
import { styles } from "../../utils/styles";

const MerchantUserSwitchView = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const [createDialog, setCreateDialog] = useState(false);

  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  return (
    <Container>
      <HeaderHelpPage title="Merchant User" description="This page manages merchant user who access to Merchant portal." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        {userRole.includes("Add") && selectedView === "All" && (
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                writeLog('[Info] - Click button [Add new merchant user] - Open new tab to Create a new account');
                setCreateDialog(true);
              }}
              startIcon={<Add />}
              sx={{ ...styles.customButton }}
            >
              Add New Merchant User
            </Button>
          </Box>
        )}
        
        <TabPanel value="All">
          <ViewMerchantUser userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingMerchantUser userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryMerchantUser userRole={userRole} />
        </TabPanel>
      </TabsMenu>

      {createDialog && <CreateNewMerchantUser open={true} onClose={() => setCreateDialog(false)} />}
    </Container>
  );
};

export default MerchantUserSwitchView;
